"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var Add = function (props) {
    return ((0, jsx_runtime_1.jsxs)(Icon_1.default, tslib_1.__assign({}, props, { children: [(0, jsx_runtime_1.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M97 24C100.314 24 103 26.6863 103 30L103 162C103 165.314 100.314 168 97 168C93.6863 168 91 165.314 91 162L91 30C91 26.6863 93.6863 24 97 24Z' }), (0, jsx_runtime_1.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M24 96C24 92.6863 26.6863 90 30 90L162 90C165.314 90 168 92.6863 168 96C168 99.3137 165.314 102 162 102L30 102C26.6863 102 24 99.3137 24 96Z' })] })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = Add;
